"use client";

import { useStrictLocalization } from "@faire/web/common/localization";
import * as React from "react";

import { IProps, LoadingSkeletonBase } from "./LoadingSkeletonBase";

/**
 * @trackcomponent
 */
export const LoadingSkeleton: React.FC<IProps> = ({ ariaLabel, ...rest }) => {
  const { strictLocalize } = useStrictLocalization();
  const ariaLabelWithFallback =
    ariaLabel ??
    strictLocalize({
      id: "eyTJgl",
      defaultMessage: "Loading",
      description: {
        text: "Message for screen readers when buttons just show a loading skeleton with no text",
      },
    });
  return <LoadingSkeletonBase {...rest} ariaLabel={ariaLabelWithFallback} />;
};
